import { compact } from 'lodash';

import { type GenerationTool, getSectionToolsOptions } from 'src/data/generationTool';

export const getInfinityToolOptions = () => {
  return getSectionToolsOptions({
    targetType: 'infinity',
    withFreeStyle: true,
  });
};

export const getInfinityTools = (): GenerationTool[] => {
  const options = getSectionToolsOptions({
    targetType: 'infinity',
    withFreeStyle: true,
    withoutSubHeaders: true,
  });

  return compact(options.map((option) => option.tool));
};
